import $ from 'jquery';
import { logShopAdClick, logShopAdImpression } from 'chairisher/analytics/promotedlistings';

import { isBot } from 'chairisher/context/auth';
import { CollectionPosition } from 'chairisher/util/analytics';
import { observeIntersectionOnce } from 'chairisher/view/helper/intersectionobserver';

const ShopAdAnalytics = {
    /**
     * Initializes analytics for shop ad click event listeners
     *
     * @param {string} trackingPosition represents where the ad is located on a given page
     */
    initializeShopAdClickListeners(trackingPosition) {
        if (!isBot()) {
            const $shopAds = $('.js-shop-ad');
            $.each($shopAds, (i, el) => {
                $(el).on('click', 'a', (e) => {
                    const $link = $(e.target);
                    const $shopAd = $link.closest('.js-shop-ad');
                    const isPromo = $shopAd.data('is-promotional');
                    const defaultTrackingPosition = `${CollectionPosition.BOTTOM_BANNER} (position ${i + 1})`;
                    logShopAdClick({
                        adName: isPromo ? 'PAS info request' : $shopAd.data('shop-title'),
                        adUrl: isPromo ? '' : $link.attr('href'),
                        analyticsPosition: trackingPosition || defaultTrackingPosition,
                        dealerGuid: $shopAd.data('dealer-guid'),
                    });
                });
            });
        }
    },

    /**
     * Initializes analytics for shop ad click event listeners and shop ad impressions
     *
     * @param {string} trackingPosition represents where the ad is located on a given page
     */
    initializeShopAdClickListenersAndImpressions(trackingPosition) {
        ShopAdAnalytics.initializeShopAdImpressions(trackingPosition);
        ShopAdAnalytics.initializeShopAdClickListeners(trackingPosition);
    },

    /**
     * Initializes analytics for logging shop ad impressions
     *
     * @param {string} trackingPosition represents where the ad is located on a given page
     */
    initializeShopAdImpressions(trackingPosition) {
        if (!isBot()) {
            const $shopAds = $('.js-shop-ad');
            $.each($shopAds, (i, el) => {
                observeIntersectionOnce(el, (entry) => {
                    const $ad = $(entry.target);
                    const dealerGuid = $ad.data('dealer-guid');
                    const analyticsPosition =
                        trackingPosition || `${CollectionPosition.BOTTOM_BANNER} (position ${i + 1})`;
                    logShopAdImpression(analyticsPosition, dealerGuid);
                });
            });
        }
    },
};

export default ShopAdAnalytics;
